import React from 'react'
// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'
// icons
import BusinessCenterIconOrigin from '@mui/icons-material/BusinessCenterOutlined'
import LockIconOrigin from '@mui/icons-material/LockOutlined'
import CheckedOriginIcon from '@mui/icons-material/Check'
// utils
import { size } from 'polished'

const BusinessCenterIcon = styled((props) => <BusinessCenterIconOrigin {...props} />)`
  && {
    fill: ${({ isActive }) => (isActive ? colors.gray300 : colors.gray850)};
  }
`

const CheckedIcon = styled(CheckedOriginIcon)`
  margin-left: 8px;
  right: 0;
  width: 20px;
  height: 20px;
`

const Header = styled.div`
  color: ${colors.blue500};
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: start;
  flex: 1;
  border-bottom: 1px solid ${colors.blue500};
  position: relative;
  height: 32px;

  span {
    text-transform: uppercase;
  }
`

const LockIcon = styled(({ isActive, ...props }) => <LockIconOrigin {...props} />)`
  && {
    fill: ${({ isActive }) => (isActive ? colors.gray850 : colors.gray300)};
  }
`

const PermissionOptionTitle = styled('div')`
  display: flex;
  font-size: 13px;
  
  p {
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
  }

  svg {
    ${size('14px')}
  }
`

const PermissionOptionWrapper = styled('div')<{ isActive: boolean }>`
  color: ${({ isActive }) => (isActive ? colors.gray850 : colors.gray300)};
  cursor: pointer;
  font-size: 11px;
  padding: 0 8px;
  max-width: 354px;
  margin-bottom: 8px;

  p {
    margin: 0;
  }

  svg:first-child {
    margin-right: 4px;
  }

  svg {
    ${size('16px')}
  }
`

const Wrapper = styled('div')`
  padding: 8px;

  > div:first-child {
    font-size: 12px;
    margin-bottom: 16px;
  }

  .MuiFormLabel-root {
    font-size: 17px;
  }
`

export { BusinessCenterIcon, CheckedIcon, Header, LockIcon, PermissionOptionTitle, PermissionOptionWrapper, Wrapper }
